module.exports = __webpack_public_path__ + "img/right-arrow.7db6c30f.png";